/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Sortby1Inputs */

const id_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan berdasarkan`)
};

const ms_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun mengikut`)
};

const da_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter efter`)
};

const de_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

const en_us2_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by`)
};

const es_es2_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const es_mx2_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const fil_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ayon sa`)
};

const fr_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par`)
};

const it_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per`)
};

const hu_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezés`)
};

const nl_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteren op`)
};

const no_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter etter`)
};

const pl_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj według`)
};

const pt_br2_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const pt_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const ro_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează după`)
};

const fi_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä`)
};

const sv_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera efter`)
};

const vi_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo`)
};

const tr_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırala`)
};

const cs_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit podle`)
};

const bg_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране по`)
};

const ru_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать по`)
};

const uk_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати за`)
};

const ar_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب حسب`)
};

const hi_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसके अनुसार क्रमबद्ध करें`)
};

const th_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดเรียงตาม`)
};

const ja_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並び替え`)
};

const zh_cn2_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const zh_hant1_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const ko_search_sort_sortby1 = /** @type {(inputs: Search_Sort_Sortby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬 기준`)
};

/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {Search_Sort_Sortby1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_sortby1 = /** @type {((inputs?: Search_Sort_Sortby1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Sortby1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_sortby1(inputs)
	if (locale === "ms") return ms_search_sort_sortby1(inputs)
	if (locale === "da") return da_search_sort_sortby1(inputs)
	if (locale === "de") return de_search_sort_sortby1(inputs)
	if (locale === "en-US") return en_us2_search_sort_sortby1(inputs)
	if (locale === "es-ES") return es_es2_search_sort_sortby1(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_sortby1(inputs)
	if (locale === "fil") return fil_search_sort_sortby1(inputs)
	if (locale === "fr") return fr_search_sort_sortby1(inputs)
	if (locale === "it") return it_search_sort_sortby1(inputs)
	if (locale === "hu") return hu_search_sort_sortby1(inputs)
	if (locale === "nl") return nl_search_sort_sortby1(inputs)
	if (locale === "no") return no_search_sort_sortby1(inputs)
	if (locale === "pl") return pl_search_sort_sortby1(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_sortby1(inputs)
	if (locale === "pt") return pt_search_sort_sortby1(inputs)
	if (locale === "ro") return ro_search_sort_sortby1(inputs)
	if (locale === "fi") return fi_search_sort_sortby1(inputs)
	if (locale === "sv") return sv_search_sort_sortby1(inputs)
	if (locale === "vi") return vi_search_sort_sortby1(inputs)
	if (locale === "tr") return tr_search_sort_sortby1(inputs)
	if (locale === "cs") return cs_search_sort_sortby1(inputs)
	if (locale === "bg") return bg_search_sort_sortby1(inputs)
	if (locale === "ru") return ru_search_sort_sortby1(inputs)
	if (locale === "uk") return uk_search_sort_sortby1(inputs)
	if (locale === "ar") return ar_search_sort_sortby1(inputs)
	if (locale === "hi") return hi_search_sort_sortby1(inputs)
	if (locale === "th") return th_search_sort_sortby1(inputs)
	if (locale === "ja") return ja_search_sort_sortby1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_sortby1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_sortby1(inputs)
	return ko_search_sort_sortby1(inputs)
});
export { search_sort_sortby1 as "search.sort.sortBy" }